export const TEXT_COLORS = {
  '#000000': '#FFFFFF',
  '#444444': '#FFFFFF',
  '#666666': '#FFFFFF',
  '#999999': '#000000',
  '#CCCCCC': '#000000',
  '#E0E0E0': '#000000',
  '#EAEAEA': '#000000',
  '#F5F5F5': '#000000',
  '#EA3323': '#FFFFFF',
  '#F19E38': '#000000',
  '#FFFF54': '#000000',
  '#75FB4C': '#000000',
  '#75FBFD': '#000000',
  '#0000F5': '#FFFFFF',
  '#8C1AF5': '#FFFFFF',
  '#EA33F7': '#FFFFFF',
  '#EECDCD': '#000000',
  '#F8E6D0': '#000000',
  '#FDF2D0': '#000000',
  '#DCE9D5': '#000000',
  '#D3DFE2': '#000000',
  '#D3E1F1': '#000000',
  '#D8D2E7': '#000000',
  '#E6D2DC': '#000000',
  '#DE9D9B': '#000000',
  '#F2CDA2': '#000000',
  '#FBE6A2': '#000000',
  '#BCD6AC': '#000000',
  '#A9C3C8': '#000000',
  '#A7C4E5': '#000000',
  '#B2A7D3': '#000000',
  '#CEA8BC': '#000000',
  '#D16D6A': '#000000',
  '#ECB576': '#000000',
  '#F9DA78': '#000000',
  '#9DC384': '#000000',
  '#80A4AE': '#000000',
  '#7CA6D7': '#FFFFFF',
  '#8B7DBE': '#FFFFFF',
  '#B87E9E': '#FFFFFF',
  '#BB271A': '#000000',
  '#DA954B': '#000000',
  '#EAC451': '#000000',
  '#78A65A': '#FFFFFF',
  '#54808C': '#FFFFFF',
  '#5083C1': '#FFFFFF',
  '#634FA2': '#FFFFFF',
  '#9B5277': '#FFFFFF',
  '#8C1A11': '#FFFFFF',
  '#A96324': '#000000',
  '#B89230': '#FFFFFF',
  '#48752C': '#FFFFFF',
  '#264E5A': '#FFFFFF',
  '#25528F': '#FFFFFF',
  '#321D70': '#FFFFFF',
  '#6B2246': '#FFFFFF',
  '#5D0E07': '#FFFFFF',
  '#704216': '#FFFFFF',
  '#7A611D': '#FFFFFF',
  '#314D1C': '#FFFFFF',
  '#18333C': '#FFFFFF',
  '#173660': '#FFFFFF',
  '#1E134A': '#FFFFFF',
  '#46162F': '#FFFFFF',
};

export const getTextColor = bgColor => TEXT_COLORS[bgColor];

export const COLORS = {
  '#000000': 'gmantra-color-0',
  '#444444': 'gmantra-color-1',
  '#666666': 'gmantra-color-2',
  '#999999': 'gmantra-color-3',
  '#CCCCCC': 'gmantra-color-4',
  '#E0E0E0': 'gmantra-color-5',
  '#EAEAEA': 'gmantra-color-6',
  '#F5F5F5': 'gmantra-color-7',
  '#EA3323': 'gmantra-color-8',
  '#F19E38': 'gmantra-color-9',
  '#FFFF54': 'gmantra-color-10',
  '#75FB4C': 'gmantra-color-11',
  '#75FBFD': 'gmantra-color-12',
  '#0000F5': 'gmantra-color-13',
  '#8C1AF5': 'gmantra-color-14',
  '#EA33F7': 'gmantra-color-15',
  '#EECDCD': 'gmantra-color-16',
  '#F8E6D0': 'gmantra-color-17',
  '#FDF2D0': 'gmantra-color-18',
  '#DCE9D5': 'gmantra-color-19',
  '#D3DFE2': 'gmantra-color-20',
  '#D3E1F1': 'gmantra-color-21',
  '#D8D2E7': 'gmantra-color-22',
  '#E6D2DC': 'gmantra-color-23',
  '#DE9D9B': 'gmantra-color-24',
  '#F2CDA2': 'gmantra-color-25',
  '#FBE6A2': 'gmantra-color-26',
  '#BCD6AC': 'gmantra-color-27',
  '#A9C3C8': 'gmantra-color-28',
  '#A7C4E5': 'gmantra-color-29',
  '#B2A7D3': 'gmantra-color-30',
  '#CEA8BC': 'gmantra-color-31',
  '#D16D6A': 'gmantra-color-32',
  '#ECB576': 'gmantra-color-33',
  '#F9DA78': 'gmantra-color-34',
  '#9DC384': 'gmantra-color-35',
  '#80A4AE': 'gmantra-color-36',
  '#7CA6D7': 'gmantra-color-37',
  '#8B7DBE': 'gmantra-color-38',
  '#B87E9E': 'gmantra-color-39',
  '#BB271A': 'gmantra-color-40',
  '#DA954B': 'gmantra-color-41',
  '#EAC451': 'gmantra-color-42',
  '#78A65A': 'gmantra-color-43',
  '#54808C': 'gmantra-color-44',
  '#5083C1': 'gmantra-color-45',
  '#634FA2': 'gmantra-color-46',
  '#9B5277': 'gmantra-color-47',
  '#8C1A11': 'gmantra-color-48',
  '#A96324': 'gmantra-color-49',
  '#B89230': 'gmantra-color-50',
  '#48752C': 'gmantra-color-51',
  '#264E5A': 'gmantra-color-52',
  '#25528F': 'gmantra-color-53',
  '#321D70': 'gmantra-color-54',
  '#6B2246': 'gmantra-color-55',
  '#5D0E07': 'gmantra-color-56',
  '#704216': 'gmantra-color-57',
  '#7A611D': 'gmantra-color-58',
  '#314D1C': 'gmantra-color-59',
  '#18333C': 'gmantra-color-60',
  '#173660': 'gmantra-color-61',
  '#1E134A': 'gmantra-color-62',
  '#46162F': 'gmantra-color-63',
};

export const COLORS_CODES = Object.keys(COLORS);

export const COLORS_REVERSE = Object.fromEntries(
  Object.entries(COLORS).map(([key, value]) => [value, key]),
);
